import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/risk-reward-calculator',
  component: () => import('../../routes/RiskRewardCalculator.svelte'),
  card: {
    id: 'risk-reward-calculator',
    title: 'Risk/Reward Ratio',
    description: 'Calculate risk/reward ratio to evaluate potential trade setups and breakeven win rates.',
    icon: 'balanced',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/risk-reward-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Risk/Reward Ratio Calculator – Evaluate Trade Setups',
    description:
      'Free risk/reward ratio calculator for traders. Enter entry, stop-loss, and take-profit prices to calculate your risk/reward ratio and breakeven win rate for any trade.',
  },
};

export default meta;
